import { defineNuxtPlugin } from "#imports";
export default defineNuxtPlugin(({ vueApp }) => {
});
